<!-- ======================[رسپانسیو}======== -->
<div class="lg:hidden">
  <ng-container *ngIf="!loading">
    <a [href]="link + url" target="_blank" class="grid grid-cols-4 mb-8 box-mobile-card rounded-3xl px-2 py-3">
      <div class="w-28">
        <img
          class="img-card2 w-full"
          [src]="contentUrl + item.cardImagePath"
          [alt]="item.altImage"
          width="112"
          loading="lazy"
          height="139"/>
      </div>
      <div class="col-span-3 mr-12 flex items-center">
        <div>
          <p>{{ item.title }}</p>
          <div class="flex mt-6 flex-wrap">
            <p class="date-card ml-8">
              بروز رسانی: {{ item.updateDate | jalaliDate}}
            </p>
            <p class="date-card">
              زمان مطالعه: {{ item.studyTime.split(":")[1] }} دقیقه
            </p>
          </div>
        </div>
      </div>
    </a>
  </ng-container>
</div>


<a [href]="link + url" class="mb-8 items-center hidden lg:flex lg:w-[60rem] xl:w-[50rem] 2xl:w-[60rem]" target="_blank">
  <div #boxCard class="box-card">

     <div class="flex flex-col justify-between h-full lg:basis-3/4 xl:basis-2/3 2xl:basis-3/4 py-6 pr-6">
      <div>
        <p class="text-black xl:text-lg 2xl:text-xl font-bold text-justify">
          {{ item.title }}
        </p>
        <p class="font-semibold text-[#9F9F9F] 2xl text-sm text-end my-3 fade-move">
          زمان مطالعه : {{ item.studyTime.split(":")[1] }} دقیقه
        </p>
        <div #divider class="divider-blog-card"></div>
      </div>


      <div class="flex justify-between items-center fade-move">
        <div class="flex items-center">
          <img class="ml-3 w-12 mb-2 lg:mb-0" height="24" width="24" loading="lazy" src="../../../../../assets/img/avatar.webp" alt="avatar">
          <p class="text-sm text-[#3246D3] font-semibold">
            نویسنده:
            <br>
            {{ item.updatedByFirstName }} {{ item.updatedByLastName }}
          </p>
        </div>
        <i class="arrow-top 2xl:w-8 w-6"></i>
        <div class="flex flex-col">
          <p class="text-sm">بروز رسانی: {{ item.updateDate | jalaliDate}}</p>
          <div class="flex items-center text-sm mt-2">
            <!-- ====[تعداد لایک.]=== -->
            <!-- <div class="ml-1 -mb-1">
              <app-favorite
              [readonly]="false"
              [rowID]="item.id"
              (liked)="like($event)"
              [tableType]="1"
            ></app-favorite>
            </div>
            <p class="ml-3">{{ item.favoriteCount ? item.favoriteCount : "&nbsp;" }}</p> -->
            <i class="ml-1 w-5 mb-1 comment-icon-gray"></i>
            <p class="ml-2">{{item.commentCount}}</p>
            <i class="eye-icon ml-1 mb-1"></i>
            <p>{{ item.viewsCount + 250}}</p>
          </div>
        </div>
      </div>
      <p class="brief-card" #briefCard>{{ item.brief }}</p>
     </div>
     <img class="img-card absolute h-40 rounded-xl -left-36 w-72" [src]="contentUrl + item.cardImagePath" loading="lazy" [alt]="item.altImage">

   </div>
  </a>